import { render, staticRenderFns } from "./TabItemHeader.vue?vue&type=template&id=99b3f8c6&"
import script from "./TabItemHeader.vue?vue&type=script&lang=js&"
export * from "./TabItemHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports